import { createSelector } from '@reduxjs/toolkit'

export const getWalletBalanceSelector = createSelector(
  (state: AppState) => state.wallet.balance,
  (value) => value
)
export const getWalletLoadingSelector = createSelector(
  (state: AppState) => state.wallet.loading,
  (value) => value
)
